import ProjectTemplate from './ProjectTemplate'

export default ProjectTemplate
